<div class="p-2 md:p-4">
  <div class="flex align-items-center justify-content-between mb-4">
    <h2 class="text-2xl font-semibold m-0" data-clarity-unmask="true">Dodaj nowy rozdział</h2>
    <p-button
      [text]="true"
      [rounded]="true"
      icon="pi pi-times"
      (onClick)="closeDialog()"
      data-clarity-unmask="true"
    ></p-button>
  </div>

  <div class="flex align-items-center justify-content-center mb-4">
    <div class="flex align-items-center">
      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center border-circle"
          [ngClass]="{
            'bg-primary text-white': currentStep >= 1,
            'border-primary text-primary': currentStep < 1
          }"
          style="width: 32px; height: 32px; border: 2px solid"
        >
          <span class="font-semibold">1</span>
        </div>
        <span
          class="ml-2 font-medium"
          [ngClass]="{ 'text-primary': currentStep >= 1 }"
          >Dane podstawowe</span
        >
      </div>

      <div
        class="mx-3 step-line"
        style="width: 60px; height: 2px; background-color: #e2e8f0"
        [ngClass]="{ 'bg-primary': currentStep >= 2 }"
      ></div>

      <div class="flex align-items-center">
        <div
          class="flex align-items-center justify-content-center border-circle"
          [ngClass]="{
            'bg-primary text-white': currentStep >= 2,
            'border-primary text-primary': currentStep < 2
          }"
          style="width: 32px; height: 32px; border: 2px solid"
        >
          <span class="font-semibold">2</span>
        </div>
        <span
          class="ml-2 font-medium"
          [ngClass]="{ 'text-primary': currentStep >= 2 }"
          >Multimedia</span
        >
      </div>
    </div>
  </div>

  <div
    *ngIf="loading"
    class="flex justify-content-center align-items-center p-4"
  >
    <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
  </div>

  <div *ngIf="currentStep === 1 && !loading">
    <form [formGroup]="topicForm">
      <div
        class="form-decorator top-decorator flex w-full justify-content-left align-items-center mt-5"
      >
        <div class="title">Przypisany dział wykładu</div>
        <p-dropdown
          [appendTo]="'body'"
          id="categoryId"
          formControlName="categoryId"
          [options]="categories"
          optionValue="id"
          optionLabel="name"
          placeholder="Wybierz dział"
          class="w-full"
          styleClass="w-full"
          (onChange)="onCategoryChange($event.value)"
        >
          <ng-template pTemplate="item" let-category>
            <div class="flex flex-column">
              <span class="font-medium">{{ category.name }}</span>
              <small
                class="text-600"
                *ngIf="
                  category.examCategories && category.examCategories.length > 0
                "
              >
                <div>
                  Kategorie egzaminów:
                  <ng-container *ngFor="let item of category.examCategories">
                    {{ item.examName }}
                  </ng-container>
                </div>
              </small>
            </div>
          </ng-template>
          <ng-template pTemplate="selectedItem" let-category>
            {{ category.name }}
          </ng-template>
        </p-dropdown>
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center"
      >
        <div class="title">Nazwa rozdziału</div>
        <input
          id="topicName"
          type="text"
          pInputText
          formControlName="name"
          placeholder="Nazwa rozdziału"
          class="w-full"
        />
      </div>

      <div
        class="form-decorator flex w-full justify-content-left align-items-center mb-6"
      >
        <div class="title">Pozycja rozdziału</div>
        <p-inputNumber
          id="topicOrder"
          formControlName="order"
          placeholder="Pozycja"
          min="0"
          max="9999"
          mode="decimal"
          [useGrouping]="false"
          styleClass="w-full"
          class="w-full"
        />
      </div>

      <div formArrayName="translations">
        <div
          *ngFor="let translationForm of translations.controls; let i = index"
          [formGroupName]="i"
        >
          <div
            class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center"
            (click)="toggleTranslationCollapse(i)"
          >
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-flag"></i>
              <div class="font-medium">
                Wersja językowa {{ i + 1 }}
                <span *ngIf="translationForm.get('languageCode')?.value">
                  -
                  {{
                    getLanguageName(translationForm.get("languageCode")?.value)
                  }}</span
                >
              </div>
            </div>
            <i
              class="pi"
              [ngClass]="
                isTranslationCollapsed(i) ? 'pi-chevron-down' : 'pi-chevron-up'
              "
            ></i>
          </div>

          <div *ngIf="!isTranslationCollapsed(i)">
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Wybierz język</div>
              <p-dropdown
                [options]="getAvailableLanguagesForTranslation(i)"
                optionLabel="name"
                optionValue="code"
                placeholder="Wybierz język"
                class="w-full"
                styleClass="w-full"
                formControlName="languageCode"
              >
              </p-dropdown>
            </div>
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Nazwa</div>
              <input
                type="text"
                pInputText
                formControlName="name"
                placeholder="Nazwa rozdziału"
              />
            </div>
            <div class="flex w-full justify-content-end form-decorator bottom-primary-decorator">
              <p-button
                label="Usuń tą wersję językową"
                icon="pi pi-trash"
                (onClick)="removeTranslationForm(i); $event.stopPropagation()"
                data-clarity-unmask="true"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="canAddMoreTranslations()"
        class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center mb-3"
        (click)="addNewTranslationForm()"
      >
        <div class="add-translation">Dodaj kolejną wersję językową</div>
        <i class="add-translation pi pi-plus"></i>
      </div>
    </form>

    <div class="flex justify-content-end gap-3">
      <p-button
        label="Anuluj"
        [outlined]="true"
        (onClick)="closeDialog()"
        data-clarity-unmask="true"
      >
      </p-button>
      <p-button
        label="Dalej"
        icon="pi pi-angle-right"
        iconPos="right"
        (onClick)="nextStep()"
        [disabled]="!isStep1ValidPublic()"
        data-clarity-unmask="true"
      >
      </p-button>
    </div>
  </div>

  <div *ngIf="currentStep === 2 && !loading">
    <div class="mb-4">
      <div
        class="form-decorator top-decorator bottom-primary-decorator flex w-full justify-content-left align-items-center mt-4"
      >
        <div class="title">Standardowa wersja PL</div>
        <fas-services-upload
          [environment]="environment.webApiUrl"
          [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
          [mainIcon]="'pi-image'"
          [multiple]="false"
          mainMessage="Wybierz plik graficzny z dysku lub przeciągnij tu."
          (fileSelected)="onFileSelected($event, 'pl')"
          class="w-full"
        >
        </fas-services-upload>
      </div>

      <div>
        <div
          *ngFor="let imageKey of getSelectedImageLanguages(); let i = index"
        >
          <div
            class="form-decorator off-bottom-border cursor-pointer flex w-full justify-content-between align-items-center"
            (click)="toggleImageLanguageCollapse(imageKey)"
          >
            <div class="flex gap-2 align-items-center">
              <i class="pi pi-image"></i>
              <div class="font-medium">
                Plik graficzny dla języka: {{ getLanguageName(imageKey) }}
              </div>
            </div>
            <i
              class="pi"
              [ngClass]="
                isImageLanguageCollapsed(imageKey)
                  ? 'pi-chevron-down'
                  : 'pi-chevron-up'
              "
            ></i>
          </div>

          <div *ngIf="!isImageLanguageCollapsed(imageKey)">
            <div
              class="form-decorator off-bottom-border flex w-full justify-content-left align-items-center"
            >
              <div class="title">Wersja {{ getLanguageName(imageKey) }}</div>
              <fas-services-upload
                [environment]="environment.webApiUrl"
                [allowedExtensions]="['.png', '.jpg', '.jpeg', 'webp']"
                [mainIcon]="'pi-image'"
                mainMessage="Wybierz plik graficzny z dysku lub przeciągnij tu."
                [multiple]="false"
                (fileSelected)="onFileSelected($event, imageKey)"
                class="w-full"
              >
              </fas-services-upload>
            </div>
            <div class="flex w-full justify-content-end form-decorator bottom-primary-decorator">
              <p-button
                label="Usuń Plik graficzny dla tego języka"
                icon="pi pi-trash"
                (onClick)="
                  removeImageLanguage(imageKey); $event.stopPropagation()
                "
                data-clarity-unmask="true"
              >
              </p-button>
            </div>
          </div>
        </div>
      </div>

      <div
        *ngIf="canAddMoreImageLanguages()"
        class="form-decorator cursor-pointer flex w-full justify-content-between align-items-center mb-3"
        (click)="showAddImageLanguageDropdown = !showAddImageLanguageDropdown"
      >
        <div class="add-translation">Dodaj plik graficzny dla kolejnego języka</div>
        <i class="add-translation pi pi-plus"></i>
      </div>

      <div
        *ngIf="showAddImageLanguageDropdown && canAddMoreImageLanguages()"
        class="form-decorator flex w-full justify-content-left align-items-center mb-3"
      >
        <div class="title">Wybierz język</div>
        <p-dropdown
          [appendTo]="'body'"
          [options]="getAvailableLanguagesForImages()"
          optionLabel="name"
          optionValue="code"
          placeholder="Wybierz język dla zdjęcia"
          class="w-full"
          styleClass="w-full"
          [(ngModel)]="selectedNewImageLanguage"
          (onChange)="onNewImageLanguageSelected()"
        >
        </p-dropdown>
      </div>
    </div>

    <div class="flex justify-content-between gap-3">
      <p-button
        label="Wstecz"
        icon="pi pi-arrow-left"
        [outlined]="true"
        (onClick)="previousStep()"
        data-clarity-unmask="true"
      ></p-button>
      <p-button
        label="Zapisz rozdział"
        icon="pi pi-check"
        (onClick)="saveTopic()"
        [disabled]="!topicForm.valid || !areAllImagesUploaded() || loading"
        [loading]="loading"
        data-clarity-unmask="true"
      ></p-button>
    </div>
  </div>
</div>
